import styled from "styled-components";

export const Root = styled.div`
  min-height: calc(100vh - 64px - 60px);
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
